import ApiClasses from './api-classes.js';

/**
 *
 * @param urls
 * @param user_key
 * @returns {Promise<unknown[]>}
 */
export async function axiosGETWithUserKey(urls, user_key) {
    return await ApiClasses.axiosGETWithUserKey(urls, user_key);
}

export async function fetchPdfLink(apiURL,screen,data_type,redirect_url) {
    const userKey = await ApiClasses.getTempApiKey(apiURL);
    const filter = {where: {and: [{screen: screen}, {data_type: data_type}]}};
    const url = apiURL + "v_portal_texts?filter=" + JSON.stringify(filter);

    try {
        const responses = await ApiClasses.axiosGETWithUserKey(
            [
                url,
            ], userKey);
        if (responses.length > 0 && responses[0].data.length > 0 && responses[0].data[0].url) {
            return responses[0].data[0].url;
        }
    } catch (error) {
        ApiClasses.handleAxiosError(error, redirect_url);
    }
}

/**
 *
 * @param apiURL
 * @param server_env
 * @return {Promise<*>}
 */
export async function getApps(apiURL, server_env) {
    return await ApiClasses.getApps(apiURL, server_env);
}

/**
 * Use this to edit data for MTS roles
 * @param apiURL
 * @param mts_payload
 * @return {Promise<any>}
 */
export async function editMTSManagerInfo(apiURL, mts_payload) {
    return await ApiClasses.editMTSManagerInfo(apiURL, mts_payload);
}

/**
 * Use this to add data to MTS roles
 * @param apiURL
 * @param mts_payload
 * @return {Promise<any>}
 */
export async function addMTSManagerInfo(apiURL, mts_payload) {
    return await ApiClasses.addMTSManagerInfo(apiURL, mts_payload);
}

/**
 *
 * @param items
 * @return {*}
 */
export function sanitizeDAMPayload(items) {
    return ApiClasses.sanitizeDAMPayload(items);
}

/**
 *
 * @param apiURL
 * @return {Promise<*>}
 */
export async function fetchMTSManagers(apiURL) {
    return await ApiClasses.fetchMTSManagers(apiURL);

}

export function notEmpty(response) {
    return ApiClasses.notEmpty(response);
}

/**
 *
 * @param urls
 * @param user_key
 * @returns {Promise<unknown[]>}
 */
export async function axiosGET(urls, user_key) {
    return await ApiClasses.axiosGET(urls, user_key);
}

/**
 *
 * @param apiURL
 * @param email
 * @param password
 * @returns {Promise<*>}
 */
export async function login(apiURL, email, password) {
    return await ApiClasses.login(apiURL, email, password);
}

/**
 *
 * @param apiURL
 * @param screen
 * @return {Promise<*>}
 */
export async function findScreen(apiURL, screen) {
    return await ApiClasses.findScreen(apiURL, screen);
}

export async function getCollaboratorList(apiURL) {
    return await ApiClasses.getCollaboratorList(apiURL);
}

export async function createAccount(apiURL, payload) {
    return await ApiClasses.createAccount(apiURL, payload);
}


export async function postSubmission(apiURL, payload) {
    return await ApiClasses.postSubmission(apiURL, payload);
}


export async function fetchSubmissionMessage(apiURL, submission_type) {
    return await ApiClasses.fetchSubmissionMessage(apiURL, submission_type);
}


export async function confirmAccount(apiURL, token) {
    return await ApiClasses.confirmAccount(apiURL, token);
}


export async function passwordResetRequest(apiURL, payload) {
    return await ApiClasses.passwordResetRequest(apiURL, payload);
}

export async function passwordResetVerified(apiURL, payload) {
    return await ApiClasses.passwordResetVerified(apiURL, payload);
}

/**
 *
 * @param url
 * @param api_key
 * @returns {Promise<*>}
 */
async function getAPI(url, api_key) {
    return await ApiClasses.getAPI(url, api_key);
}

export async function getPublicResources(apiURL) {
    return await ApiClasses.getPublicResources(apiURL);
}

export async function getTempApiKey(apiURL) {
    return await ApiClasses.getTempApiKey(apiURL);
}

/**
 *
 * @param resource
 * @returns {Promise<boolean>}
 */
export async function anonymousResources(resource, apiURL) {
    return await ApiClasses.anonymousResources(resource, apiURL);
}

/**
 *
 * @param url
 * @param user_key
 * @param payload
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export async function axiosPostAPIKey(url, user_key, payload) {
    return await ApiClasses.axiosPostAPIKey(url, user_key, payload);
}

/**
 *
 * @param url
 * @param user_key
 * @param payload
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export async function axiosPost(url, user_key, payload) {
    return await ApiClasses.axiosPost(url, user_key, payload);
}

export async function signFile(project, file_url, api_url, user_key) {
    return await ApiClasses.signFile(project, file_url, api_url, user_key);
}

/**
 *
 * @param error
 * @param redirect_url
 */
export function handleAxiosError(error, redirect_url) {
    return ApiClasses.handleAxiosError(error, redirect_url);
}

export function get_USER_KEY() {
    return ApiClasses.get_USER_KEY();
}


export function get_PARAMS() {
    return ApiClasses.get_PARAMS()
}

// export function get_COMPOUND(){
//   const compound = localStorage.getItem('compound');
//   return JSON.parse(compound)
// }

export function get_PROJECT_RESOURCES() {
    return ApiClasses.get_PROJECT_RESOURCES()
}

export function get_COMPOUND() {
    return ApiClasses.get_COMPOUND()
}

export function get_SCREEN() {
    return ApiClasses.get_SCREEN()
}

export function get_COMPOUND_OVERVIEW() {
    return ApiClasses.get_COMPOUND_OVERVIEW()
}

export function userAuth() {
    return ApiClasses.userAuth()
}

